import React, { useMemo, useState } from 'react';
import { Controller } from 'react-hook-form';
import { Form, Spin, Upload } from 'antd';
import _ from 'lodash';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import Request from 'common/network/Request';

const UploadImages = ({
  control,
  setError,
  errors,
  data = {},
  onUploading,
}) => {
  const [uploading, setUploading] = useState(false);

  const uploadFile = async (options, onUploadSuccess) => {
    if (_.get(data.images, 'length', 0) >= 2) {
      setError('images', {
        type: 'manual',
        message: 'Chỉ được tải lên tối đa 2 ảnh!',
      });
      return;
    }
    setUploading(true);
    onUploading(true);
    const { onSuccess, file, onProgress } = options;

    try {
      let result;

      result = await Request.post(
        '/sale/upload-file',
        {
          upload_file: file,
          uploadFileField: 'upload_file',
        },
        {
          onUploadProgress: (event) => {
            if (event.loaded == event.total) {
              onSuccess({ percent: (event.loaded / event.total) * 100 }, file);
            } else {
              onProgress({ percent: (event.loaded / event.total) * 100 }, file);
            }
          },
        },
      );

      if (result.success) {
        let fileData = {
          uid: file.uid,
          id: result.result.id,
          name: result.result.name,
          status: 'done',
          url: result.result.path,
        };

        onUploadSuccess(_.concat(data.images, [fileData]).filter(Boolean));
      }
    } catch (error) {
      console.error(error);
    }

    setUploading(false);
    onUploading(false);
  };

  const fileList = useMemo(() => {
    return !_.isEmpty(data.images)
      ? _.map(data.images, (val) => ({
          ...val.value,
          url: `${process.env.REACT_APP_API_SERVER}/${val.url}`,
        }))
      : [];
  }, [data.images]);

  return (
    <Form.Item
      label="Ảnh đính kèm"
      validateStatus={errors.images ? 'error' : ''}
      help={errors.images?.message}
    >
      <Controller
        control={control}
        name="images"
        render={({ field }) => {
          return (
            <Spin spinning={uploading}>
              <Upload
                customRequest={(options) => uploadFile(options, field.onChange)}
                onRemove={(value) => {
                  field.onChange(
                    _.filter(
                      field.value,
                      (val) =>
                        `${process.env.REACT_APP_API_SERVER}/${val.url}` !==
                        value.url,
                    ),
                  );
                }}
                defaultFileList={[]}
                multiple={false}
                listType="picture-card"
                fileList={fileList}
                maxCount={2}
                accept="image/jpg,image/png,image/jpeg"
                className={twMerge(
                  clsx(
                    '[&_.ant-upload-list-item-container]:!h-[165px] [&_.ant-upload-list-item-container]:!flex-1',
                    _.get(field.value, 'length', 0) >= 2 &&
                      '[&_.ant-upload-select]:!hidden',
                  ),
                )}
              >
                {'+ Tải lên'}
              </Upload>
            </Spin>
          );
        }}
      />
    </Form.Item>
  );
};

export default UploadImages;
